import React from 'react';
import '../App.css'; // optional for custom styling

const WhyChooseUs = () => {
  return (
          <section className="py-5 text-white" style={{ background: 'linear-gradient(to right, #38C6C3,rgb(56, 198, 153))' }}>
  <div className="container">
    <h2 className="text-center mb-4 fw-bold text-uppercase">Why Businesses Choose FTTBSA</h2>

    <div className="row text-center">
      {[
        { icon: "bi-speedometer2", title: "High-Speed Performance", desc: "Blazing-fast fibre speeds tailored to power your business." },
        { icon: "bi-wifi", title: "Reliable Uptime", desc: "Stay connected with 99.9% uptime—ideal for VoIP, Zoom, cloud tools." },
        { icon: "bi-box-seam", title: "Custom Business Packages", desc: "From startups to enterprises, choose what fits you best." },
        { icon: "bi-headset", title: "24/7 Support", desc: "Local support team always ready to assist." },
        { icon: "bi-shield-lock", title: "Secure & Scalable", desc: "Built with business security in mind, and ready to grow." },
        { icon: "bi-cash-stack", title: "No Hidden Fees", desc: "Transparent billing with no unexpected surprises." },
      ].map((benefit, idx) => (
        <div className="col-md-4 mb-4" key={idx}>
          <div className="p-4 h-100 bg-white rounded shadow-sm" style={{color:'#0f174f'}}>
            <i className={`bi ${benefit.icon} fs-1 text-orange mb-3`}></i>
            <h5 className="fw-bold mb-2 text-orange">{benefit.title}</h5>
            <p className="mb-0">{benefit.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
  );
};

export default WhyChooseUs;
